import { css } from "@emotion/css";
import { LegacyCard } from "@octopusdeploy/design-system-components";
import { PlusIcon, ShieldHalvedIcon } from "@octopusdeploy/design-system-icons";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
export interface AddPolicyStarterCardProps {
    title: string;
    description: string;
    cardType: "blank" | "default";
    onClick?: () => void;
    selected?: boolean;
}
export function AddPolicyStarterCard({ title, description, cardType, onClick, selected }: AddPolicyStarterCardProps) {
    const handleClick = (e: React.MouseEvent) => {
        if (onClick) {
            e.preventDefault();
            onClick();
        }
    };
    const icon = <div className={styles.iconContainer}>{cardType === "blank" ? <PlusIcon size={36} color={themeTokens.color.text.info}/> : <ShieldHalvedIcon size={36} color={themeTokens.color.text.info}/>}</div>;
    const card = (<LegacyCard link={onClick ? (<a href="#" onClick={handleClick} className={styles.link}>
                        Select {title}
                    </a>) : null} logo={icon} header={<div className={styles.header(cardType)}>{title}</div>} content={description} className={styles.card(selected ?? false, cardType)} contentClassName={styles.content} leftAlign={true} isDisabled={false}/>);
    return card;
}
const styles = {
    card: (selected: boolean, cardType: "blank" | "default") => {
        const isBlank = cardType === "blank";
        const getBackgroundColor = () => {
            return isBlank ? themeTokens.color.background.secondary.default : themeTokens.color.background.primary.default;
        };
        const getHoverColor = () => {
            return isBlank ? themeTokens.color.background.secondary.hover : themeTokens.color.background.primary.hover;
        };
        const getPressedColor = () => {
            return isBlank ? themeTokens.color.background.secondary.pressed : themeTokens.color.background.primary.pressed;
        };
        const getBorderColor = () => {
            if (selected) {
                return themeTokens.color.border.selected;
            }
            return "transparent";
        };
        const getBoxShadow = () => {
            if (isBlank)
                return "unset";
            if (selected)
                return themeTokens.shadow.medium;
            return themeTokens.shadow.small;
        };
        return css({
            "&&": {
                flex: "1 1 0",
                minWidth: "100%",
                maxWidth: "100%",
                width: "auto",
                gap: space[4],
                margin: 0,
                padding: space[16],
                backgroundColor: getBackgroundColor(),
                border: `2px solid ${getBorderColor()}`,
                boxShadow: getBoxShadow(),
                "@media (min-width: 600px)": {
                    minWidth: "230px",
                    maxWidth: "calc((100% - 32px) / 3)",
                },
                "&:hover": {
                    backgroundColor: getHoverColor(),
                },
                "&:active": {
                    backgroundColor: getPressedColor(),
                },
            },
        });
    },
    header: (cardType: "blank" | "default") => css({
        font: text.body.bold.medium,
        lineHeight: "1.5rem",
        marginTop: space[2],
        color: cardType === "blank" ? themeTokens.color.button.text.quiet : themeTokens.color.text.primary,
    }),
    content: css({
        font: text.body.regular.small,
        margin: 0,
    }),
    link: css({ opacity: 0 }),
    iconContainer: css({
        height: space[40],
        width: space[40],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }),
};
